document.addEventListener('DOMContentLoaded', () => {
  try {
    document.querySelectorAll('.size-chart-section').forEach(section => {
      // Determine type: tops/shirts or pants
      const isPants = section.classList.contains('size-chart-pants');

      // Select correct data sources
      const sizeChartData = isPants ? (window.sizeChartDataPants || {}) : (window.sizeChartData || {});
      const linePositions = isPants ? (window.linePositionsPants || {}) : (window.linePositions || {});

      const silhouette = section.querySelector('.size-chart-silhouette');
      const selector = section.querySelector('.size-selector');
      const productType = section.dataset.productType;
      const silhouetteUrl = section.dataset.silhouetteUrl;

      console.log('Section:', section);
      console.log('Is Pants:', isPants);
      console.log('Product Type:', productType);
      console.log('Silhouette URL:', silhouetteUrl);
      console.log('Size Chart Data:', sizeChartData);
      console.log('Line Positions:', linePositions);

      section.querySelector('.size-chart-button')?.addEventListener('click', () => {
        let modal = document.querySelector('.size-chart-modal');
        if (!modal) {
          modal = section.querySelector('.size-chart-modal');
          console.log('Modal found in section (first open)');
        } else {
          console.log('Modal found in document (subsequent open)');
        }

        if (!modal) {
          console.error('Modal not found anywhere');
          return;
        }

        if (modal.parentNode !== document.body) {
          document.body.appendChild(modal);
          console.log('Moved modal to body');
        }

        modal.style.display = 'block';

        // FIXED: Reset tabs safely from the modal (not the section)
        const tabButtons = modal.querySelectorAll('.tab-button');
        const tabContents = modal.querySelectorAll('.tab-content');

        tabButtons.forEach(b => b.classList.remove('active'));
        tabContents.forEach(c => c.classList.remove('active'));

        const visualBtn = modal.querySelector('[data-tab="visual"]');
        const visualContent = modal.querySelector('.visual-tab');

        if (visualBtn) visualBtn.classList.add('active');
        if (visualContent) visualContent.classList.add('active');

        const img = document.createElement('img');
        img.src = silhouetteUrl || 'https://via.placeholder.com/500';
        img.alt = `${productType || 'Silhouette'} Silhouette`;
        img.style.maxWidth = '100%';
        img.style.height = 'auto';

        img.onload = () => {
          silhouette.innerHTML = '';
          silhouette.appendChild(img);
          drawMeasurementLines();
          updateDimensions();
        };

        img.onerror = () => console.error('Image Load Error:', silhouetteUrl);
        silhouette.appendChild(img);
      });

      // Close modal (global query since it may be moved to body)
      document.querySelector('.close-modal')?.addEventListener('click', () => {
        const modal = document.querySelector('.size-chart-modal');
        if (modal) {
          modal.style.display = 'none';
          console.log('Modal closed');
        }
      });

      // Tab switching (attached at load time using the modal)
      const modal = section.querySelector('.size-chart-modal');
      if (modal) {
        const tabButtons = modal.querySelectorAll('.tab-button');
        const tabContents = modal.querySelectorAll('.tab-content');

        tabButtons.forEach(btn => {
          btn.addEventListener('click', () => {
            tabButtons.forEach(b => b.classList.remove('active'));
            tabContents.forEach(c => c.classList.remove('active'));
            btn.classList.add('active');
            const target = modal.querySelector(`.${btn.dataset.tab}-tab`);
            if (target) target.classList.add('active');
          });
        });
      }

      function drawMeasurementLines() {
        if (!sizeChartData || !silhouette.querySelector('img')) {
          console.warn('No size data or image for lines');
          return;
        }

        const size = selector?.value || 's';
        const data = sizeChartData[size];
        if (!data) {
          console.warn('No data for size:', size);
          return;
        }

        const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        svg.setAttribute("width", "100%");
        svg.setAttribute("height", "100%");
        svg.style.position = "absolute";
        svg.style.top = "0";
        svg.style.left = "0";
        svg.style.pointerEvents = "none";

        if (isPants) {
          // Pants: Waist (horizontal) and Inseam (vertical)
          if (data.waist && data.waist !== 0) {
            const waistLine = document.createElementNS("http://www.w3.org/2000/svg", "line");
            waistLine.setAttribute("x1", linePositions.waist?.x1 || "30%");
            waistLine.setAttribute("y1", linePositions.waist?.y1 || "15%");
            waistLine.setAttribute("x2", linePositions.waist?.x2 || "70%");
            waistLine.setAttribute("y2", linePositions.waist?.y2 || "15%");
            waistLine.setAttribute("stroke", "#D3D3D3");
            waistLine.setAttribute("stroke-width", "2");
            waistLine.setAttribute("stroke-dasharray", "5");
            svg.appendChild(waistLine);
          }

          if (data.inseam && data.inseam !== 0) {
            const inseamLine = document.createElementNS("http://www.w3.org/2000/svg", "line");
            inseamLine.setAttribute("x1", linePositions.inseam?.x1 || "50%");
            inseamLine.setAttribute("y1", linePositions.inseam?.y1 || "20%");
            inseamLine.setAttribute("x2", linePositions.inseam?.x2 || "50%");
            inseamLine.setAttribute("y2", linePositions.inseam?.y2 || "85%");
            inseamLine.setAttribute("stroke", "#D3D3D3");
            inseamLine.setAttribute("stroke-width", "2");
            inseamLine.setAttribute("stroke-dasharray", "5");
            svg.appendChild(inseamLine);
          }
        } else {
          // Tops: Chest, Length, Sleeve (original logic)
          if (data.chest_width && data.chest_width !== 0) {
            const chestLine = document.createElementNS("http://www.w3.org/2000/svg", "line");
            chestLine.setAttribute("x1", linePositions.chest?.x1 || "28%");
            chestLine.setAttribute("y1", linePositions.chest?.y1 || "40%");
            chestLine.setAttribute("x2", linePositions.chest?.x2 || "72%");
            chestLine.setAttribute("y2", linePositions.chest?.y2 || "40%");
            chestLine.setAttribute("stroke", "#D3D3D3");
            chestLine.setAttribute("stroke-width", "2");
            chestLine.setAttribute("stroke-dasharray", "5");
            svg.appendChild(chestLine);
          }

          if (data.length && data.length !== 0) {
            const lengthLine = document.createElementNS("http://www.w3.org/2000/svg", "line");
            lengthLine.setAttribute("x1", linePositions.length?.x1 || "63%");
            lengthLine.setAttribute("y1", linePositions.length?.y1 || "9%");
            lengthLine.setAttribute("x2", linePositions.length?.x2 || "63%");
            lengthLine.setAttribute("y2", linePositions.length?.y2 || "90%");
            lengthLine.setAttribute("stroke", "#D3D3D3");
            lengthLine.setAttribute("stroke-width", "2");
            lengthLine.setAttribute("stroke-dasharray", "5");
            svg.appendChild(lengthLine);
          }

          if (data.sleeve_length && data.sleeve_length !== 0) {
            const sleeveLine = document.createElementNS("http://www.w3.org/2000/svg", "line");
            sleeveLine.setAttribute("x1", linePositions.sleeve?.x1 || "25%");
            sleeveLine.setAttribute("y1", linePositions.sleeve?.y1 || "15%");
            sleeveLine.setAttribute("x2", linePositions.sleeve?.x2 || "20%");
            sleeveLine.setAttribute("y2", linePositions.sleeve?.y2 || "47%");
            sleeveLine.setAttribute("stroke", "#D3D3D3");
            sleeveLine.setAttribute("stroke-width", "2");
            sleeveLine.setAttribute("stroke-dasharray", "5");
            svg.appendChild(sleeveLine);
          }
        }

        silhouette.appendChild(svg);
      }

      function updateDimensions() {
        const size = selector?.value || 's';
        const data = sizeChartData[size];
        const img = silhouette.querySelector('img');

        if (!img) {
          console.warn('No image for dimensions');
          return;
        }

        let overlay = silhouette.querySelector('.dimension-overlay');
        if (!overlay) {
          overlay = document.createElement('div');
          overlay.className = 'dimension-overlay';
          overlay.style.position = 'absolute';
          overlay.style.top = '0';
          overlay.style.left = '0';
          overlay.style.width = '100%';
          overlay.style.height = '100%';
          overlay.style.pointerEvents = 'none';
          silhouette.appendChild(overlay);
        } else {
          overlay.innerHTML = '';
        }

        if (data) {
          if (isPants) {
            // Pants: Waist and Inseam labels
            const waistDiv = document.createElement('div');
            waistDiv.style.position = 'absolute';
            waistDiv.style.left = '39%'; // Adjust % based on your pants silhouette
            waistDiv.style.top = '18%';
            waistDiv.style.color = '#506455';
            waistDiv.style.fontFamily = 'new-spirit, sans-serif';
            waistDiv.style.fontWeight = '500';
            waistDiv.style.fontSize = '16px';
            waistDiv.textContent = data.waist ? `Waist: ${data.waist}in` : 'Waist: N/A';
            waistDiv.classList.add('measurement-bg');
            overlay.appendChild(waistDiv);

            const inseamDiv = document.createElement('div');
            inseamDiv.style.position = 'absolute';
            inseamDiv.style.left = '45%';
            inseamDiv.style.top = '52%';
            inseamDiv.style.color = '#506455';
            inseamDiv.style.fontFamily = 'new-spirit, sans-serif';
            inseamDiv.style.fontWeight = '500';
            inseamDiv.style.fontSize = '16px';
            inseamDiv.textContent = data.inseam ? `Inseam: ${data.inseam}in` : 'Inseam: N/A';
            inseamDiv.classList.add('vertical-rotated', 'measurement-bg');
            overlay.appendChild(inseamDiv);
          } else {
            // Tops: Chest, Length, Sleeve labels (your original positioning)
            const chestDiv = document.createElement('div');
            chestDiv.style.position = 'absolute';
            chestDiv.style.left = '37%';
            chestDiv.style.top = '35%';
            chestDiv.style.color = '#506455';
            chestDiv.style.fontFamily = 'new-spirit, sans-serif';
            chestDiv.style.fontWeight = '500';
            chestDiv.textContent = data.chest_width ? `Chest: ${data.chest_width}in` : 'Chest: N/A';
            chestDiv.classList.add('measurement-bg');
            overlay.appendChild(chestDiv);

            const lengthDiv = document.createElement('div');
            lengthDiv.style.position = 'absolute';
            lengthDiv.style.left = '44%';
            lengthDiv.style.top = '56%';
            lengthDiv.style.color = '#506455';
            lengthDiv.style.fontFamily = 'new-spirit, sans-serif';
            lengthDiv.style.fontWeight = '500';
            lengthDiv.textContent = data.length ? `Length: ${data.length}in` : 'Length: N/A';
            lengthDiv.classList.add('vertical-rotated', 'measurement-bg');
            overlay.appendChild(lengthDiv);

            if (data.sleeve_length) {
              const sleeveDiv = document.createElement('div');
              sleeveDiv.style.position = 'absolute';
              sleeveDiv.style.left = '28%';
              sleeveDiv.style.top = '20%';
              sleeveDiv.style.color = '#506455';
              sleeveDiv.style.fontFamily = 'new-spirit, sans-serif';
              sleeveDiv.style.fontWeight = '500';
              sleeveDiv.textContent = `Sleeve: ${data.sleeve_length}in`;
              overlay.appendChild(sleeveDiv);
            }
          }
        }
      }

      selector?.addEventListener('change', () => {
        drawMeasurementLines();
        updateDimensions();
      });

      setTimeout(() => {
        drawMeasurementLines();
        updateDimensions();
      }, 100);
    });
  } catch (error) {
    console.error('Size Chart Script Error:', error);
  }
});